import { Autocomplete, Box, Button, TextField } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";
import Loader from "components/Loader";
import { snack } from "components/toast";
import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ResType } from "types";

import { getAtomClients } from "api/services/gstr/client"; 
import { addMcaCredential } from "api/services/mca/mca-client";
import { getMcaClients } from "api/services/mca/mca";

const AddMcaCredentials = (props: any) => {
  const { open, setOpen } = props;
  const queryClient = useQueryClient();

  const [clientError, setClientError] = useState(false);
  const [selectedClient, setSelectedClient] = useState<any>(null);

  const { data: clients, isLoading: clientsLoading }: ResType = useQuery(
    ["clients-mca"],
    getMcaClients, 
    { enabled: open }
  );

  const { mutate, isLoading } = useMutation(addMcaCredential, {
    onSuccess: () => {
      snack.success("MCA client added successfully");

      setSelectedClient(null);
      queryClient.invalidateQueries("get-mca-client");

      setOpen(false);
    },
    onError: (err: any) => {
      snack.error(
        err?.response?.data?.message || "Error adding MCA client"
      );
    },
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!selectedClient?.id) {
      setClientError(true);
      return;
    }

    mutate({
      clientId: selectedClient.id,
    });
  };

  const handleCancel = () => {
    setSelectedClient(null);
    setClientError(false);
    setOpen(false);
  };

  if (clientsLoading) return <Loader />;

  return (
    <DialogWrapper
      title="Add MCA Client"
      open={open}
      setOpen={setOpen}
    >
      <form onSubmit={handleSubmit}>
        <Box mt={3} display="flex" flexDirection="column">
          <Autocomplete
            options={clients?.data || []}
            getOptionLabel={(option) => option.displayName || ""}
            value={selectedClient}
            onChange={(e, newValue) => {
              setSelectedClient(newValue);
              setClientError(false);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                fullWidth
                required
                label="Select Client"
                error={clientError}
                helperText={
                  clientError ? "Please select a client" : ""
                }
              />
            )}
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                {option.displayName}
              </li>
            )}
            isOptionEqualToValue={(option, value) =>
              option.id === value?.id
            }
          />

          <Box
            display="flex"
            justifyContent="flex-end"
            mt={3}
          >
            <Button
              onClick={handleCancel}
              sx={{ width: "100px", mr: 2 }}
              color="secondary"
              variant="outlined"
            >
              Cancel
            </Button>

            <Button
              sx={{ width: "100px" }}
              disabled={isLoading}
              type="submit"
              variant="contained"
            >
              Save
            </Button>
          </Box>
        </Box>
      </form>
    </DialogWrapper>
  );
};

export default AddMcaCredentials;
